import { supabase } from '../../lib/supabaseClient';
import type { Tables } from '../../types/database.types';

export type StatsDossiersByStage = Tables<'v_stats_dossiers_by_stage'>;
export type StatsDossiersByType = Tables<'v_stats_dossiers_by_type'>;
export type StatsRevenueMonthly = Tables<'v_stats_revenue_monthly'>;
export type StatsHoursByLawyer = Tables<'v_stats_hours_by_lawyer'>;
export type StatsDossierProfitability = Tables<'v_stats_dossier_profitability'>;

export async function listStatsDossiersByStage(): Promise<StatsDossiersByStage[]> {
  const { data, error } = await supabase
    .from('v_stats_dossiers_by_stage')
    .select('*');
  if (error) throw error;
  return data ?? [];
}

export async function listStatsDossiersByType(): Promise<StatsDossiersByType[]> {
  const { data, error } = await supabase
    .from('v_stats_dossiers_by_type')
    .select('*');
  if (error) throw error;
  return data ?? [];
}

export async function listStatsRevenueMonthly(): Promise<StatsRevenueMonthly[]> {
  const { data, error } = await supabase
    .from('v_stats_revenue_monthly')
    .select('*')
    .order('month_start', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function listStatsHoursByLawyer(): Promise<StatsHoursByLawyer[]> {
  const { data, error } = await supabase
    .from('v_stats_hours_by_lawyer')
    .select('*')
    .order('hours_total', { ascending: false });
  if (error) throw error;
  return data ?? [];
}

export async function listStatsDossierProfitability(): Promise<StatsDossierProfitability[]> {
  const { data, error } = await supabase
    .from('v_stats_dossier_profitability')
    .select('*');
  if (error) throw error;
  return data ?? [];
}
